import React, { Component } from "react";
import classNames from "classnames";
import { withTranslation } from "react-i18next";
import WidgetContainer from "../WidgetContainer/WidgetContainer";

import "./LanguageSwitcher.css";

class LanguageSwitcher extends Component {
    constructor(props) {
        super(props);
        this.handleChangeLanguage = this.handleChangeLanguage.bind(this);
    }
    handleChangeLanguage(lng) {
        const { i18n } = this.props;
        i18n.changeLanguage(lng);
    }
    renderLanguageChoice({ code, label }) {
        const buttonClass = classNames("language-switcher__button", {
            "language-switcher__button--selected":
                this.props.i18n.language === code,
        });
        return (
            <span
                key={code}
                className={buttonClass}
                onClick={() => this.handleChangeLanguage(code)}
            >
                {label}
            </span>
        );
    }
    render() {
        const languages = [
            { code: "en", label: "English" },
            { code: "gu", label: "ગુજરતી" },
            { code: "ta", label: "தமிழ்" },
            { code: "te", label: "తెలుగు" },
            { code: "mr", label: "मराठी" },
            { code: "ml", label: "മലയാളം" },
            { code: "as", label: "অসমীয়া" },
            { code: "bn", label: "বাংলা" },
            { code: "hi", label: "हिंदी" },
            { code: "kn", label: "ಕನ್ನಡ" },
            { code: "or", label: "ଓଡ଼ିଆ" },
        ];
        return (
            <WidgetContainer stylesClass="language-sw">
                <div className="language-switcher">
                    {languages.map(language =>
                        this.renderLanguageChoice(language)
                    )}
                </div>
            </WidgetContainer>
        );
    }
}
export default withTranslation("")(LanguageSwitcher);
